import { defineMessages } from 'react-intl'

const scope = `procurify.components.WithTaxTooltip`

export default defineMessages({
  customAmountLabel: {
    id: `${scope}.customAmountLabel`,
    defaultMessage: 'Custom $',
  },
  customPercentLabel: {
    id: `${scope}.customPercentLabel`,
    defaultMessage: 'Custom %',
  },
})
